import { useContext } from 'react';
import { ReportContext } from '../../../context/ReportContext';
import SimpleDataGrid from '../../Tables/SimpleDataGrid';
import SimpleDataGridItem from '../../Tables/SimpleDataGridItem';
import ExpandableInfoCard, {
    ExpandableInfoCardDescription,
    ExpandableInfoCardDetail,
} from '../../Cards/ExpandableInfoCard';

const toPercentStr = (value) =>
    value === null || value === undefined || Number.isNaN(value)
        ? '-'
        : `${(value * 100).toFixed(0)}%`;

// No charting; render sectioned tables

const UserMoneyPersonalityAggregate = () => {
    const { reportData } = useContext(ReportContext);

    // API returns a single aggregate object
    const data = reportData ?? {};

    return (
        <div>
            <div className="space-y-6">
                <div>
                    <h2 className="font-semibold text-slate-800 mb-2">Totals</h2>
                    <SimpleDataGrid>
                        <SimpleDataGridItem
                            label="Total Starts:"
                            value={data.totalStarts}
                        />
                        <SimpleDataGridItem
                            label="Total Completes:"
                            value={data.totalCompletes}
                        />
                    </SimpleDataGrid>
                </div>

                <div>
                    <h2 className="font-semibold text-slate-800 mb-2">Outlook</h2>
                    <SimpleDataGrid>
                        <SimpleDataGridItem
                            label="Skeptical:"
                            value={toPercentStr(data.outlookSkeptical)}
                        />
                        <SimpleDataGridItem
                            label="Confident:"
                            value={toPercentStr(data.outlookConfident)}
                        />
                        <SimpleDataGridItem
                            label="Optimistic:"
                            value={toPercentStr(data.outlookOptimistic)}
                        />
                    </SimpleDataGrid>
                </div>

                <div>
                    <h2 className="font-semibold text-slate-800 mb-2">Influence</h2>
                    <SimpleDataGrid>
                        <SimpleDataGridItem
                            label="Independent:"
                            value={toPercentStr(data.influenceIndependent)}
                        />
                        <SimpleDataGridItem
                            label="Elusive:"
                            value={toPercentStr(data.influenceElusive)}
                        />
                        <SimpleDataGridItem
                            label="Social:"
                            value={toPercentStr(data.influenceSocial)}
                        />
                    </SimpleDataGrid>
                </div>

                <div>
                    <h2 className="font-semibold text-slate-800 mb-2">Focus</h2>
                    <SimpleDataGrid>
                        <SimpleDataGridItem
                            label="Future Focused:"
                            value={toPercentStr(data.focusFutureFocused)}
                        />
                        <SimpleDataGridItem
                            label="Present Focused:"
                            value={toPercentStr(data.focusPresentFocused)}
                        />
                    </SimpleDataGrid>
                </div>

                <div>
                    <h2 className="font-semibold text-slate-800 mb-2">Emotions</h2>
                    <SimpleDataGrid>
                        <SimpleDataGridItem
                            label="Apprehensive:"
                            value={toPercentStr(data.emotionsApprehensive)}
                        />
                        <SimpleDataGridItem
                            label="Relaxed:"
                            value={toPercentStr(data.emotionsRelaxed)}
                        />
                        <SimpleDataGridItem
                            label="Cautious:"
                            value={toPercentStr(data.emotionsCautious)}
                        />
                    </SimpleDataGrid>
                </div>

                <div>
                    <h2 className="font-semibold text-slate-800 mb-2">Bonus</h2>
                    <SimpleDataGrid>
                        <SimpleDataGridItem
                            label="Fun Seeking:"
                            value={toPercentStr(data.bonusFunSeeking)}
                        />
                        <SimpleDataGridItem
                            label="Change Seeking:"
                            value={toPercentStr(data.bonusChangeSeeking)}
                        />
                        <SimpleDataGridItem
                            label="Organized:"
                            value={toPercentStr(data.bonusOrganized)}
                        />
                    </SimpleDataGrid>
                </div>

                <ExpandableInfoCard title="What is this data?">
                    <ExpandableInfoCardDescription>
                        This report provides aggregate statistics for Money Personality
                        assessments over the selected time period and filters. The
                        percentages show the distribution of personality traits across all
                        completed assessments.
                    </ExpandableInfoCardDescription>
                    <ExpandableInfoCardDetail name="Total Starts">
                        The total number of users who began the Money Personality
                        assessment.
                    </ExpandableInfoCardDetail>
                    <ExpandableInfoCardDetail name="Total Completes">
                        The total number of users who completed the Money Personality
                        assessment.
                    </ExpandableInfoCardDetail>
                    <ExpandableInfoCardDetail name="Outlook">
                        The user's viewpoint of money.
                    </ExpandableInfoCardDetail>
                    <ExpandableInfoCardDetail name="Influence">
                        How others impact the user's money decisions.
                    </ExpandableInfoCardDetail>
                    <ExpandableInfoCardDetail name="Focus">
                        Whether the user's focus is on the present or future.
                    </ExpandableInfoCardDetail>
                    <ExpandableInfoCardDetail name="Emotions">
                        How the user feels about money.
                    </ExpandableInfoCardDetail>
                    <ExpandableInfoCardDetail name="Bonus">
                        A noted personality trait of the user.
                    </ExpandableInfoCardDetail>
                </ExpandableInfoCard>
            </div>
        </div>
    );
};

export default UserMoneyPersonalityAggregate;
